import { useEffect } from "react";
import { useSelector } from "react-redux";
import { SERVER_URL } from "../api";

function buildFullUrl(value) {
	if (!value || typeof value !== "string") return null;
	if (value.startsWith("http")) return value;
	return `${SERVER_URL.replace(/\/$/, "")}/${value.replace(/^\//, "")}`;
}

function looksLikeAssetUrl(value) {
	if (!value || typeof value !== "string") return false;
	const v = value.trim();
	if (v.startsWith("http")) return true;
	if (v.startsWith("/") || v.startsWith("uploads")) return true;
	if (/\.(png|jpg|jpeg|gif|webp|svg|mp4|webm)(\?|$)/i.test(v)) return true;
	return false;
}

/**
 * Precarga en segundo plano las imágenes/URLs que vienen en los textos del juego.
 * Así cuando el usuario avance a la siguiente pantalla, los recursos ya están en caché.
 */
export function usePreloadGameAssets() {
	const group = useSelector((state) => state?.group);
	const gameId = group?.game;
	const texts = useSelector((state) =>
		gameId && state.gameTexts?.[gameId] ? state.gameTexts[gameId] : {}
	);

	useEffect(() => {
		if (!gameId || Object.keys(texts).length === 0) return;

		const urlsToPreload = new Set();
		Object.values(texts).forEach((value) => {
			if (looksLikeAssetUrl(value)) {
				const url = buildFullUrl(value);
				if (url) urlsToPreload.add(url);
			}
		});

		urlsToPreload.forEach((url) => {
			const ext = (url.split("?")[0] || "").toLowerCase();
			if (ext.endsWith(".mp4") || ext.endsWith(".webm")) {
				const video = document.createElement("video");
				video.preload = "metadata";
				video.src = url;
			} else {
				const img = new Image();
				img.src = url;
			}
		});
	}, [gameId, texts]);
}
